import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import FormInput from "../inputs/FormInput";
import Text from "../Text";
import { TextSize } from "../utils/TextSize";
import { LoadingButton } from "@mui/lab";
import { ShownTaskForm, useTaskFormStore } from "../../stores/useTaskFormStore";
import AddLocalTaskForm from "./AddLocalTaskForm";
import CheckBoxInput from "../inputs/CheckBoxInput";
import AddJiraTaskForm from "./AddJiraTaskForm";
import BatchAddJiraModal from "./BatchAddJiraModal";

const AddTaskForm = () => {
    const form = useTaskFormStore((state) => state.form);
    const setForm = useTaskFormStore((state) => state.setForm);
    const [batchModalOpen, setBatchModalOpen] = useState(false);

    const toggle = () =>
        setForm(
            form === ShownTaskForm.Add
                ? ShownTaskForm.JiraAdd
                : ShownTaskForm.Add
        );
    return (
        <Stack spacing={2}>
            {form !== ShownTaskForm.AddChild && (
                <>
                    <CheckBoxInput
                        checked={form === ShownTaskForm.JiraAdd}
                        name="Add new task from Jira"
                        onClick={toggle}
                    />
                    <Button
                        variant="outlined"
                        color="info"
                        size="small"
                        onClick={() => setBatchModalOpen(true)}
                    >
                        <Text size={TextSize.Small}>Batch Add from Jira</Text>
                    </Button>
                </>
            )}
            {form === ShownTaskForm.Add || form === ShownTaskForm.AddChild ? (
                <AddLocalTaskForm />
            ) : (
                form === ShownTaskForm.JiraAdd && <AddJiraTaskForm />
            )}
            <BatchAddJiraModal
                open={batchModalOpen}
                onClose={() => setBatchModalOpen(false)}
            />
        </Stack>
    );
};

export default AddTaskForm;
